import { InhalerCompliance, InhalerProduct, InhalerTypes } from '@/jsonapi/CommonTypes'

function getInhalersByType(t: InhalerTypes) {
  return function(allInhalers: InhalerProduct[]) {
    return allInhalers.filter(x => x.productType === t)
  }
}

function getInhalerCompliancesByType(t: InhalerTypes) {
  return function(allCompliances: InhalerCompliance[]) {
    return allCompliances.filter(x => x.productType === t)
  }
}

export default {
  getRescueInhalers: getInhalersByType(InhalerTypes.Reliever),
  getMaintenanceInhalers: getInhalersByType(InhalerTypes.Maintenance),
  getRescueInhalerCompliances: getInhalerCompliancesByType(InhalerTypes.Reliever),
  getMaintenanceInhalerCompliances: getInhalerCompliancesByType(InhalerTypes.Maintenance),
}
